import intl from 'react-intl-universal';

export function validate(name: string, setError: (error: string) => void) {
  if (!name) {
    setError(intl.get('validation.name.cannotBeEmptyError'));
    return false;
  }
  setError('');
  return true;
}
